<template>
  <div class="home">
    <div class="fmbox" v-if="adback">
      <van-button
        class="enter"
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        @click="enterHome"
        >{{ adn }} 欢迎访问</van-button
      >
      <img src="../assets/fm01.jpg" width="100%" alt />
    </div>
    <!-- 搜索区块 
    <div class="search-box">
      <img height="45px" src="../assets/gzmalogo.png" />
      <van-search v-model="value" show-action label placeholder="搜索我感兴趣的" @search="onSearch">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>-->

    <!-- 轮播图片 -->
    <van-swipe :autoplay="3000" indicator-color="#fff">
      <van-swipe-item v-for="(NewsItem, index) in BannerList" :key="index">
        <router-link
          @click.native="goToUrl(NewsItem)"
          :to="{ path: $route.fullPath }"
        >
          <img :src="NewsItem.PicPath.split(',')[0]" />
        </router-link>
      </van-swipe-item>
    </van-swipe>

    <!-- 主导航 -->
    <div class="mainnav">
      <router-link
        v-for="(item, index) in mainnavimg"
        :key="index"
        :to="item.navurl"
      >
        <img :src="item.imgurl" alt />
        <p>{{ item.name }}</p>
      </router-link>
    </div>
    <!-- 公告栏 -->
    <!-- <div class="notice">
        <van-notice-bar left-icon="volume-o" :scrollable="false">
          <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :show-indicators="false"
          >
            <van-swipe-item><a href="https://mp.weixin.qq.com/s/CaAtCIbBPT0agDtNpz__sA">线上音乐考级贵州考区视频录制要求</a></van-swipe-item>   
            <van-swipe-item class="danger">系统正在调试测试中，敬请期待！</van-swipe-item>       
          </van-swipe>
        </van-notice-bar>
    </div>-->
    <!-- <div class="remark">
      <p>温馨提示：线上缴费仅限贵阳地区考生，其它各地州根据当地考级办的要求办理！</p>
    </div>-->
    <!-- 快速导航 -->
    <div class="quick-nav">
      <van-grid :column-num="4">
        <van-grid-item
          v-for="(item, index) in navimg"
          :key="index"
          :icon="item.imgurl"
          :to="item.navurl"
          @click="PopupDev(item)"
          :text="item.name"
        />
      </van-grid>
    </div>
    <van-popup v-model="show" :close-on-click-overlay="false"
      >数据传输故障，正在紧急维护中，请耐心等待。</van-popup
    >
    <footerTabber />
    <copyright />
  </div>
</template>

<script>
import Vue from "vue";
import copyright from "@/components/copyright.vue";
import footerTabber from "@/components/footerTabber.vue";
import { Toast, Dialog } from "vant";
import { GetNewsList } from "@/api/public";
Vue.use(Toast);
export default {
  name: "Home",
  components: {
    footerTabber,
    copyright
  },
  data() {
    return {
      show: false,
      adback: true,
      adn: 3,
      adtime: null,
      value: "",
      mainnavimg: [
        {
          name: "协会组织",
          imgurl: require("../assets/sy-10.png"),
          navurl: "/Channels?CID=2"
        },
        {
          name: "音乐考级",
          imgurl: require("../assets/sy-11.png"),
          navurl: "/ExamCenter"
        },
        {
          name: "会员管理",
          imgurl: require("../assets/sy-12.png"),
          navurl: "/VipCenter"
        },
        {
          name: "八方音讯",
          imgurl: require("../assets/sy-13.png"),
          navurl: "/NewsList?CID=1"
        }
      ],
      navimg: [
        {
          name: "黔音坊",
          imgurl: require("../assets/sy-02.png"),
          navurl: "/Channels?CID=5"
        },
        {
          name: "音乐名家",
          imgurl: require("../assets/sy-03.png"),
          navurl: "/Channels?CID=6"
        },
        {
          name: "活动启事",
          imgurl: require("../assets/sy-04.png"),
          navurl: "/Channels?CID=7"
        },
        {
          name: "协会乐刊",
          imgurl: require("../assets/sy-05.png"),
          navurl: "/Channels?CID=8"
        },
        {
          name: "黔音课堂",
          imgurl: require("../assets/sy-06.png"),
          navurl: "/Channels?CID=9"
        },
        {
          name: "考级动态",
          imgurl: require("../assets/sy-09.png"),
          navurl: "/NewsList?CID=20"
        },
        {
          name: "乐器商城",
          imgurl: require("../assets/sy-07.png"),
          navurl: "/Channels?CID=10"
        },
        {
          name: "下载中心",
          imgurl: require("../assets/sy-08.png"),
          navurl: "/Channels?CID=11"
        }
      ],
      hotnews: [
        {
          name: "歌曲征市歌曲征集111",
          imgurl: require("../assets/pic1.jpg"),
          navurl: ""
        },
        {
          name: "在线歌曲征集｜安顺市创建全国文明城市歌曲征集考试",
          imgurl: require("../assets/pic1.jpg"),
          navurl: ""
        },
        {
          name: "歌曲征集｜安顺市创建全国文明城市歌曲征集",
          imgurl: require("../assets/pic1.jpg"),
          navurl: ""
        }
      ],

      BannerList: []
    };
  },
  methods: {
    PopupDev(item) {
      if (item.navurl == "") Toast.fail("敬请期待！");
    },
    enterHome() {
      this.adback = false;
      localStorage.setItem("First", true);
    },
    adplay() {
      this.adtime = setInterval(this.autoadplay, 1000);
    },
    autoadplay() {
      this.adn--;
      if (this.adn == 0) {
        this.adback = false;
        clearInterval(this.adtime);
      }
    },
    goToUrl(item) {
      if (item.LinkUrl && item.LinkUrl != "") {
        window.location.href = item.LinkUrl;
      } else {
        this.$router.push({ path: `/NewsDetail?News_ID=${item.NewsID}` });
      }
    },
    GetNewsList() {
      // Dialog.alert({
      //   title: "通告",
      //   message:
      //     "各位考生，为使大家能更好的进行线上考级，我们特对14日部分考生（贵州钢琴五级）和16日部分考生（云南古筝一、二级）的考试时间进行了调整，调到8月23日。请大家重新进入系统，查看自己的考试时间，按准考证上的时间按时完成考级。如调整后时间有冲突，请联系省考级办18302574003。"
      // }).then(() => {
      //   // on close
      // });
      GetNewsList({ IsBanner: 1 }).then(res => {
        this.BannerList = res.listData;
      });
    }
  },
  mounted: function() {
    if (localStorage.getItem("First")) {
      this.adback = false;
    } else {
      localStorage.setItem("First", true);
    }
    this.adplay();
    this.GetNewsList();
  }
};
</script>

<style>
.home {
  padding: 15px 0;
  background: #f2f2f2;
  height: 100vh;
  padding-bottom: 6vh;
}

.home .search-box {
  display: flex;
  justify-content: flex-start;
  padding: 2%;
  justify-items: center;
}
.home .van-search {
  background: transparent;
  flex: 1;
}
.van-search .van-search__content {
  border-radius: 20px;
}
.van-search .van-search__content .van-cell {
  margin: 0;
}
.van-search .van-search__action {
  color: #fff;
}
.van-swipe {
  width: 96%;
  margin: 0 auto 20px;
  border-radius: 10px;
  box-shadow: 3px 3px 5px #d0c6e8;
}
.van-search .van-search__action .van-icon-search {
  color: #d2d2d2;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  text-align: center;
}

.van-swipe-item img {
  width: 100%;
  display: block;
}
.van-swipe__indicators .van-swipe__indicator--active {
  width: 5vw;
  border-radius: 10px;
}
.mainnav {
  background: #fff;
  width: 96%;
  margin: 10px auto;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 5px;
  box-sizing: border-box;
}
.mainnav a {
  display: inline-block;
  text-align: center;
  color: #333;
}
.mainnav a img {
  width: 50%;
  text-align: center;
}
.notice,
.quick-nav {
  width: 96%;
  margin: 15px auto;
  background: #fff;
  border-radius: 5px;
  padding-bottom: 15px;
}
.notice .van-notice-bar {
  background: #fff;
  border-radius: 5px;
  color: #373737;
  font-size: 4vw;
  padding: 0 8px;
}
.notice .van-notice-bar .van-icon {
  color: #fa195a;
  margin-right: 10px;
  font-weight: bold;
}
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
.notice .van-notice-bar .notice-swipe .van-swipe-item a {
  color: #373737;
}
.quick-nav .van-grid .van-grid-item .van-grid-item__content {
  padding: 8px 1px;
  background: transparent;
}
.van-grid .van-grid-item .van-grid-item__content::after,
.van-hairline--top::after {
  border: 0;
}
.quick-nav
  .van-grid
  .van-grid-item
  .van-grid-item__content
  .van-grid-item__icon {
  font-size: 12vw;
}
.quick-nav
  .van-grid
  .van-grid-item
  .van-grid-item__content
  .van-grid-item__text {
  font-weight: 300;
  color: #212121;
}
.hot-news {
  margin: 25px auto;
  width: 94.667vw;
}
.hot-news h1 {
  color: #fff;
  display: flex;
  justify-content: space-between;
  font-size: 4.267vw;
}
.hot-news a {
  color: #fff;
  border: solid 1px #fff;
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 3.2vw;
}
.hot-news .van-grid .van-grid-item .van-grid-item__content {
  padding: 16px 5px;
  background: transparent;
}
.hot-news .van-grid .van-grid-item .van-grid-item__content::after,
.quick-nav .van-hairline--top::after,
.hot-news .van-hairline--top::after {
  border: 0;
}
.hot-news
  .van-grid
  .van-grid-item
  .van-grid-item__content
  .van-grid-item__text {
  color: #fff;
  text-align: left;
  height: 5vh;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
}
.quick-nav
  .van-grid
  .van-grid-item
  .van-grid-item__content
  .van-icon
  .van-icon__image {
  width: 30%;
  height: auto;
  border-radius: 5px;
}
.remark {
  padding: 8px;
  margin: 10px auto;
}
.remark p {
  color: #fff;
  line-height: 1.5;
}
#app .home .copyright p,
#app .home .copyright p a:link {
  color: #333;
}
</style>
